var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lee-platform-container"},[_c('lee-kuaishou')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }